import React from 'react';
import {
  Box,
  Text,
  Flex,
  Card,
  Button,
  Skeleton,
  useDisclosure,
} from 'ui';
import { Address } from '@assets/images';
import {
  DOCUMENT_TYPES,
  DocumentSection,
  AddressFormModal,
  UploadFormContainer,
} from '../components';
import { useController } from './hooks';
import { style as s } from './UploadAddress.style';
import { ts } from './utils';

const type = DOCUMENT_TYPES.PROOF_OF_ADDRESS;

export const UploadAddress = () => {
  const {
    control,
    address,
    clearField,
    addressLine1,
    addressLine2,
    addressLine3,
    onUploadError,
    addressDocument,
    isAddressLoading,
    areDocumentsReady,
    onUploadCompleted,
    onRemoveCompleted,
    isDocumentsLoading,
  } = useController();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <UploadFormContainer
      t={ts}
      imageElement={<Address width="100%" height="100%" data-testid="image" />}
      type={type}
      areDocumentsReady={areDocumentsReady}
    >
      <AddressFormModal
        isOpen={isOpen}
        onCloseModal={onClose}
        onCompleted={onClose}
        address={address}
      />
      <Skeleton isLoaded={!isAddressLoading} borderRadius="lg">
        <Flex {...s.addressCard}>
          <Box>
            <Text>{ts('address')}</Text>
            <Text {...s.addressText}>{addressLine1}</Text>
            <Text {...s.addressText}>{addressLine2}</Text>
            <Text {...s.addressText}>{addressLine3}</Text>
          </Box>
          <Button
            variant="link"
            onClick={onOpen}
          >
            {ts('change')}
          </Button>
        </Flex>
      </Skeleton>
      <Card>
        <DocumentSection
          t={ts}
          name="address"
          filesCount={1}
          control={control}
          clearField={clearField}
          document={addressDocument}
          onUploadError={onUploadError}
          isDisabled={isDocumentsLoading}
          onUploadCompleted={onUploadCompleted}
          onRemoveCompleted={onRemoveCompleted}
        />
      </Card>
    </UploadFormContainer>
  );
};
